import { useEffect, useRef, useState } from 'react';

const stats = [
  { value: '10+', label: 'Años de Experiencia' },
  { value: '8+', label: 'Presencia Países' },
  { value: '200+', label: 'Miembros del Equipo' },
  { value: '1000+', label: 'Productos Distribuidos' },
];

function useVisible() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
  return { visible, ref };
}

export default function LegacySection() {
  const { visible, ref } = useVisible();

  return (
    <section ref={ref} className="py-24 md:py-32 px-6 md:px-16 lg:px-24 bg-[#f5f2ed]">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 text-center">
          {stats.map((stat, i) => (
            <div
              key={stat.label}
              className={`transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
              style={{ transitionDelay: `${i * 150}ms` }}
            >
              <div className="text-4xl md:text-5xl lg:text-6xl font-light text-gray-900 mb-3">
                {stat.value}
              </div>
              <div className="text-xs uppercase tracking-[0.2em] text-gray-500">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}